import { render } from "./debts.vue?vue&type=template&id=9915ddd6&scoped=true"
const script = {}

import "./debts.vue?vue&type=style&index=0&id=9915ddd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9915ddd6"]])

export default __exports__